

















































































import store from '../store'
import { openLinkInBrowser } from '../mla-shared'
import { printPage } from '@/mixins/mixins'

export default {
  mixins: [ printPage ],

  data () {
    return {
      title: 'Step 4',
      panels: [0, 1, 2, 3]
    }
  },

  methods: {
    externalLink(e:Event, url:string) {
      e.preventDefault();
      openLinkInBrowser(url);
    }
  },

  store
}
